module.exports = __webpack_public_path__ + "index/img/kefu.d635cf4d.svg";